import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const FAQClient = {
    /**
     *
     * Returns a faq with a given id
     */
    getFAQ(Id) {
        return clientFactory.get(API_URL + 'faqs/' + Id);
    }

};